/* eslint-disable arrow-body-style */
import React, { useEffect, useState } from "react";
import { EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import { fetchTripSummary, getTripPrices } from "modules/trips/api";
import VariableExpenses from "./VariableExpenses";
import { TripFinancialsWrapper } from "./style";
import TotalPrice from "./TotalPrice";
import TripSummary from "./TripSummary";
import TripPrice from "./TripPrice";
import Tripdocuments from "./Tripdocuments";
import OperationalExpenses from "./OperationalExpenses";

const TripFinancials = ({ tripId }) => {
    const [tripPrices, setTripPrices] = useState({});
    const [tripSummary, setTripSummary] = useState({});
    const [isPricesChanged, setIsPricesChanged] = useState(false);
    useEffect(() => {
        getTripPrices(tripId).then((data) => {
            const prices = Object.values(data?.entities?.tripPrices);
            setTripPrices((prevStat) => ({
                ...prevStat,
                ...prices[0]?.attributes,
            }));
        });
        fetchTripSummary(tripId).then((data) => {
            setTripSummary(data);
        });
    }, [tripId, isPricesChanged]);

    return (
        <TripFinancialsWrapper
            direction="column"
            gutterSize="none"
        >
            <EuiFlexItem>
                <TotalPrice prices={tripPrices} />
            </EuiFlexItem>
            <EuiFlexGroup dir="ltr">
                <EuiFlexItem grow={1}>
                    <TripSummary tripSummary={tripSummary} />
                </EuiFlexItem>
                <EuiFlexItem grow={3}>
                    <TripPrice
                        tripPrices={tripPrices}
                        tripId={tripId}
                        setIsPricesChanged={setIsPricesChanged}
                        isPricesChanged={isPricesChanged}
                    />
                </EuiFlexItem>
            </EuiFlexGroup>
            <EuiFlexGroup dir="ltr">
                <EuiFlexItem grow={1}>
                    <Tripdocuments tripId={tripId} />
                </EuiFlexItem>
                <EuiFlexItem grow={3}>
                    <OperationalExpenses
                        tripId={tripId}
                        tripPrices={tripPrices}
                        setIsPricesChanged={setIsPricesChanged}
                        isPricesChanged={isPricesChanged}
                    />
                </EuiFlexItem>
            </EuiFlexGroup>
            <EuiFlexItem>
                <VariableExpenses
                    tripId={tripId}
                    tripPrices={tripPrices}
                    setIsPricesChanged={setIsPricesChanged}
                    isPricesChanged={isPricesChanged}
                />
            </EuiFlexItem>
        </TripFinancialsWrapper>
    );
};

export default TripFinancials;
